import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreQuery } from '../firebase';
import { Match } from '../types';


interface UserMatchesState {
  matches: {
    [ userId: string ]: Match[]
  };
  loading: boolean;
}

const initialState: UserMatchesState = {
  matches: {},
  loading: false,
}



const service = createSlice({
  name: 'userMatches',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<{ isLoading: boolean, userId: string }>): UserMatchesState {
      let newState = { ...state, loading: action.payload.isLoading };

      if (!action.payload.isLoading) {
        newState = {
          ...newState,
          matches: {
            ...newState.matches,
            [action.payload.userId]: []
          }
        }
      }

      return newState;
    },
    setMatches(state, action: PayloadAction<{userId: string, matches: Match[]}>): UserMatchesState {
      return { 
        ...state, 
        matches: {
          ...state.matches,
          [action.payload.userId]: action.payload.matches,
        }, 
        loading: false,
      }
    },

  }
});



const loadMatches = (userId: string): AppThunk => async (dispatch, getState) => {
  if (getState().userMatches.matches[userId]) {
    return;
  }
  
  dispatch(service.actions.setLoading({
    userId,
    isLoading: true,
  }));

  const query = firestore.collection('matches')
    .where('users', 'array-contains', userId)
    .orderBy('createTime', 'desc')
    .limit(250);

  const result = await firestoreQuery<Match>(query);

  dispatch(service.actions.setMatches({
    userId,
    matches: result.list,
  }));
}



export const actions = {
  loadMatches,
}

export default service.reducer;